import type { SessionDto } from '@/types/dtos/sessions/session.dto';
import {
  RecordVoiceOverOutlined,
  SchoolOutlined,
  GroupOutlined,
  MicOutlined,
  ScienceOutlined,
  PeopleOutlined,
  PlaceOutlined,
  CategoryOutlined,
  PresentToAllOutlined,
  FitnessCenterOutlined,
} from '@mui/icons-material';

export default function sessionTypeToIcon(type: SessionDto['type']) {
  switch (type) {
    case 'address':
      return <PlaceOutlined />;
    case 'keynote':
      return <PresentToAllOutlined />;
    case 'talk':
      return <RecordVoiceOverOutlined />;
    case 'panel':
      return <GroupOutlined />;
    case 'pitch':
      return <MicOutlined />;
    case 'demonstration':
      return <ScienceOutlined />;
    case 'workshop':
      return <SchoolOutlined />;
    case 'exercise':
      return <FitnessCenterOutlined />;
    case 'networking':
      return <PeopleOutlined />;
    case 'other':
      return <CategoryOutlined />;
    default:
      return <RecordVoiceOverOutlined />;
  }
}
